"use client";
import React, { useState } from "react";
import { Dropdown } from "react-bootstrap-v1.6";

import defaultStyles from "./main.module.scss";

import {
  FULL_SCREEN,
  WIDE_SCREEN,
  NARROW_SCREEN,
  SCREEN_1200,
  SCREEN_900,
} from "@stadium/helpers/style";

/**
 * @deprecated Use bootstrap-dropdown from packages/ui/src/components/bootstrap-dropdown/index.tsx".
 */

const DropdownComponent = ({
  label = null,
  children = null,
  styles = defaultStyles,
  className = styles.dropdownToggle,
  disabled = false,
  menuClassName = "",
  wrapperClass = "",
  openDropdownClass = "",
  screen = FULL_SCREEN,
  renderDropdownAsBottomModal = false,
  mobileHeading = null,
  mobileHeadingClassName = "",
  onToggle = null,
  ariaLabel = "dropdown",
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownStyles = {
    [FULL_SCREEN]: styles.fullScreen,
    [WIDE_SCREEN]: styles.wideScreen,
    [NARROW_SCREEN]: styles.narrowScreen,
    [SCREEN_1200]: styles.screen1200,
    [SCREEN_900]: styles.screen900,
  };

  const onDropdownToggle = (isOpen, event, metaData) => {
    onToggle?.(isOpen, event, metaData);
    if (!disabled) setIsDropdownOpen(isOpen);
  };

  return (
    <Dropdown {...(Dropdown.defaultProps || {})} onToggle={onDropdownToggle} bsPrefix={styles.dropdown}>
      <Dropdown.Toggle
        {...(Dropdown.Toggle.defaultProps || {})}
        className={`${className} ${
          isDropdownOpen ? `${styles.openDropdown} ${openDropdownClass}` : ""
        } ${wrapperClass} ${renderDropdownAsBottomModal ? styles.mobileToggleButton : ""}`}
        disabled={disabled}
        as="div"
        bsPrefix={styles.dropdownToggleContainer}
        tabIndex="0"
        aria-label={ariaLabel}
      >
        <div className={styles.dropdownValue}>{label}</div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        {...(Dropdown.Menu.defaultProps || {})}
        bsPrefix={styles.dropdownContainer}
        className={`${dropdownStyles[screen]} ${menuClassName} ${
          renderDropdownAsBottomModal ? styles.mobileDropdown : ""
        }`}
      >
        {renderDropdownAsBottomModal && (
          <Dropdown.Toggle
            {...(Dropdown.Toggle.defaultProps || {})}
            bsPrefix={`${
              renderDropdownAsBottomModal ? styles.mobileHeading : ""
            } ${mobileHeadingClassName}`}
            as="div"
          >
            {mobileHeading} <span className={styles.closeIcon}></span>
          </Dropdown.Toggle>
        )}
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export const DropdownItem = ({
  children = null,
  styles = defaultStyles,
  className = styles.dropdownItem,
  customClassName = "",
  ...rest
}) => (
  <Dropdown.Item
    {...(Dropdown.Item.defaultProps || {})}
    as="div"
    bsPrefix="custom-dropdown-item"
    className={`${className} ${customClassName}`}
    {...rest}
  >
    {children}
  </Dropdown.Item>
);

export default DropdownComponent;
